<app-nav
  [companies]="companies"
  [menuItems]="menuItems"
  [selectedMenuItem]="selectedMenuItem"
  (handleMenuItemChange)="handleMenuItemChange($event)"
  (handleCompanyChange)="handleCompanyChange($event)"
  [selectedCompany]="selectedCompany"
></app-nav>
